var DualRowPackageWithDifferentPadsData = require('./dualRowPackageWithDifferentPadsData.js');
var lib_core = require("lib-core");
var ComponentAttribute = require('./componentAttribute.js');
var lib_geometry = require("lib-geometry");
var IPCRules = require('../ipcRules');
var EllipseData = require('../../../svg/ellipseData.js');
var PathData = require('../../../svg/pathData.js');
var PathObjectData = require('../../../svg/pathObjectData.js');
var PathType = require('../../../svg/pathType.js');

var ChipArrayFourSideFlatConcaveData = function(position, angle, init) {
    DualRowPackageWithDifferentPadsData.apply(this, arguments);

    this.oddPadWidthMax = this.value("oddPadWidthMax", true);
    this.oddPadWidthMin = this.value("oddPadWidthMin", true);

	//component family if any
    this.componentFamily = this.value("componentFamily", true);

    //lead shape
    this.leadShapeType = this.value("leadShapeType", true);

    this.nonTransformedSegmentedGeometry.addTrigger(this.oddPadWidthMax);
    this.nonTransformedSegmentedGeometry.addTrigger(this.oddPadWidthMin);
    this.nonTransformedSegmentedGeometry.addTrigger(this.componentFamily);
    this.nonTransformedSegmentedGeometry.addTrigger(this.leadShapeType);
};

lib_core.inherit(ChipArrayFourSideFlatConcaveData, DualRowPackageWithDifferentPadsData);
lib_core.JsonParser.registerClass(ChipArrayFourSideFlatConcaveData, "ChipArrayFourSideFlatConcaveData");

module.exports = ChipArrayFourSideFlatConcaveData;

ChipArrayFourSideFlatConcaveData.prototype.setupMinMaxPtrMap = function() {
    DualRowPackageWithDifferentPadsData.prototype.setupMinMaxPtrMap.call(this);
    this.minMaxPointerMap["oddPadWidth"] = [this.oddPadWidthMin, this.oddPadWidthMax];
    this.validationMap["oddPadWidthMax"] = [this.oddPadWidthMax];
};

ChipArrayFourSideFlatConcaveData.prototype.getPads = function(absolutePositions) {
    var self = this;
    var pads = [];

    //reset component
    self.component.reset();
    self.updateComponentCalculator(self.horizontalLeadToLeadSpanMin(), self.horizontalLeadToLeadSpanMax());

    var i,
        pad,
        rowIdx,
        nRow = self.component.padsPerSide[0],
        hPitch = self.component.C,
        pinPitch = self.verticalPinPitch(),
        motif1 = self.getMotif(); //motif for left and right pads

    //calculate pitch along top-down direction
    self.updateComponentCalculator(self.bodyLengthMin(), self.bodyLengthMax());
    var motif2 = self.getMotif(); //motif for top and down pads

    //update top and bottom pad size if odd dimensions are available
    if(self.oddPadHeightMax()) {
        if (self.oddPadHeightMax() !== self.padHeightMax() || self.oddPadHeightMin() !== self.padHeightMin()) {
            //update component for new pad height
            self.component.padHeightMax = self.oddPadHeightMax();
            self.component.padHeightMin = self.oddPadHeightMin();

            self.updateComponentCalculator();
            motif2 = self.getMotif();
        }
    }

    if (self.oddPadWidthMax()) {
        if (self.oddPadWidthMax() !== self.padWidthMax() || self.oddPadWidthMin() !== self.padWidthMin()) {
            //update component for new pad width
            self.component.padWidthMax = self.oddPadWidthMax();
            self.component.padWidthMin = self.oddPadWidthMin();

            self.updateComponentCalculator();
            motif2 = self.getMotif();
        }
    }

    //odd pin pitch 
    var vPitch = self.component.C;
    
    //top pad
    pad = motif2.clone();
    pad.rotate(90);
    pad.move(new lib_geometry.Coord(0, 0.5 * vPitch));
    pads.push(pad);

    //left pads
    for(i = 0; i < nRow; i++) {
        rowIdx = i % nRow;

        pad = motif1.clone();
        pad.move(new lib_geometry.Coord(-0.5 * hPitch, ((nRow - 1) / 2 - rowIdx) * pinPitch));
        pads.push(pad);
    }

    //bottom pad
    pad = motif2.clone();
    pad.rotate(90);
    pad.move(new lib_geometry.Coord(0, -0.5 * vPitch));
    pads.push(pad);

    //right pads
    for(i = 0; i < nRow; i++) {
        rowIdx = nRow - 1 - i % nRow;

        pad = motif1.clone();
        pad.move(new lib_geometry.Coord(0.5 * hPitch, ((nRow - 1) / 2 - rowIdx) * pinPitch));
        pads.push(pad);
    }

    self.updatePads(pads, absolutePositions);
    return pads;
};

/**
 * Get silkscreen pin one marker
 * @param {PadData} firstPad first pad data
 * @param {object} body body for silkscreen
 */
ChipArrayFourSideFlatConcaveData.prototype.getPinOneMarker = function(firstPad, body) {
    var pinMarkerSize = IPCRules.dotPinMarkerSize,
        pinMarkerPosX,
        pinMarkerPosY;

    //place pin marker at left side of first pad
    pinMarkerPosX = firstPad.getPos().x - firstPad.getTopCopper().height() / 2 - IPCRules.silkscreenPinMarkerDotClearance - pinMarkerSize / 2;
    pinMarkerPosY = body.height / 2 + pinMarkerSize / 2 + IPCRules.silkscreenPinMarkerDotClearance;

    return new EllipseData(new lib_geometry.Coord(pinMarkerPosX, pinMarkerPosY), 0, pinMarkerSize, pinMarkerSize, true, 0);
};

ChipArrayFourSideFlatConcaveData.prototype.getSilkscreen = function(pads) {
    var self = this;
    var silkscreen = [];

    //no silkscreen if there are no pads
    if(pads.length === 0) return silkscreen;

    //get body dimesnsions depending on mapping type of silkscreen to body
    var body = self.getBodyForSilkscreen();

    var topPad = pads[0],
        leftFirstPad = pads[1];
        
    ////////////////////
    //   Pin Marker   //
    ////////////////////

    silkscreen.push(this.getPinOneMarker(topPad, body));

    //////////////////////////////
    //   Component Silkscreen   //
    //////////////////////////////
    var pathData;

    //return if left first pad's top edge including clearence is above top pad's top edge
    if (leftFirstPad.getPos().y + leftFirstPad.getTopCopper().height() / 2 + IPCRules.silkscreenClearance + IPCRules.silkscreenStrokeWidth / 2 > topPad.getPos().y + topPad.getTopCopper().width() / 2) {
        return silkscreen;
    }

    //return if left first pad's top edge including clearence is above body top edge
    if (leftFirstPad.getPos().y + leftFirstPad.getTopCopper().height() / 2 + IPCRules.silkscreenClearance + IPCRules.silkscreenStrokeWidth / 2 > body.height / 2) {
        return silkscreen;
    }

    //top-left corner
    pathData = new PathData(new lib_geometry.Coord(-body.width / 2, leftFirstPad.getPos().y + leftFirstPad.getTopCopper().height() / 2 + IPCRules.silkscreenClearance), IPCRules.silkscreenStrokeWidth);
    pathData.addObject(new PathObjectData(new lib_geometry.Coord(-body.width / 2, body.height / 2), PathType.LINE));
    pathData.addObject(new PathObjectData(new lib_geometry.Coord(topPad.getPos().x - topPad.getTopCopper().height() / 2 - IPCRules.silkscreenClearance, body.height / 2), PathType.LINE));
    silkscreen.push(pathData);

    //top-right corner
    pathData = pathData.clone();
    pathData.flip(new lib_geometry.Line(lib_geometry.Line.VER, new lib_geometry.Coord(0, 0)));
    silkscreen.push(pathData);

    //bottom-right corner
    pathData = pathData.clone();
    pathData.flip(new lib_geometry.Line(lib_geometry.Line.HOR, new lib_geometry.Coord(0, 0)));
    silkscreen.push(pathData);

    //bottom-left corner
    pathData = pathData.clone();
    pathData.flip(new lib_geometry.Line(lib_geometry.Line.VER, new lib_geometry.Coord(0, 0)));
    silkscreen.push(pathData);

    return silkscreen;
};
